import { useSuspenseQuery } from '@tanstack/react-query';

import { DashboardApiInstance } from '~src/main/api';
import { useSiteId } from '~src/main/hooks/useSiteId';

export function useDashboardQueryKey() {
  const siteId = useSiteId();

  const keys = {
    all: ['dashboard', siteId] as const,
    lists: () => [...keys.all, 'list'] as const,
  };
  return keys;
}

export function useGetDashboardQuery() {
  const queryKey = useDashboardQueryKey();
  const siteId = useSiteId();

  return useSuspenseQuery({
    queryFn: async () => {
      const { data } = await DashboardApiInstance.dashboard.dashboardGetDashboard(siteId!, {
        dashboard_type: 'TRANSPORT_ADMINISTRATION',
      });
      return data;
    },
    queryKey: queryKey.lists(),
  });
}
